import classNames from 'classnames';
import { BtnDoubleProps } from 'eco-design-micro/props/btn/BtnDoubleProps';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import EcoButton from 'eco-design/base/eco-button';
import React from 'react';
import './index.scss';

interface EcoButtonDoubleProps extends BtnDoubleProps {
    /**
     * 主题色
     */
    theme?: 'black' | 'white';

    /**
     * 样式名
     */
    className?: string;

    /**
     * 左按钮点击事件回调
     */
    lBtnClick?: (e: React.MouseEvent<HTMLElement>) => void;
    /**
     * 右边按钮点击事件回调
     */
    rBtnClick?: (e: React.MouseEvent<HTMLElement>) => void;
    /**
     *左埋点
     */
    lDataLayer?: DataLayerProps;

    /**
     *右埋点
     */
    rDataLayer?: DataLayerProps;
}

/**
 *
 * 双按钮
 */
const EcoButtonDouble: React.FC<EcoButtonDoubleProps> = (props) => {
    const prefixCls = `eco-button-double`;
    const classes = classNames(prefixCls, {
        [`${props.className}`]: props.className,
    });

    return (
        <div className={classes}>
            {!!props.lChildren && (
                <EcoButton
                    lType={props.lType}
                    lSize={props.lSize}
                    lRadius={props.lRadius}
                    lTheme={props.lTheme}
                    lHref={props.lHref}
                    lFontColor={props.lFontColor}
                    lBgColor={props.lBgColor}
                    lBorderColor={props.lBorderColor}
                    lChildren={props.lChildren}
                    lIsWithRightArrow={props.lIsWithRightArrow}
                    onClick={props.lBtnClick}
                    lDataLayer={props?.lDataLayer}
                    lDisabled={props?.lDisabled}
                ></EcoButton>
            )}
            {!!props.rChildren && (
                <EcoButton
                    lType={props.rType}
                    lSize={props.rSize}
                    lRadius={props.rRadius}
                    lTheme={props.rTheme}
                    lHref={props.rHref}
                    lFontColor={props.rFontColor}
                    lBgColor={props.rBgColor}
                    lBorderColor={props.rBorderColor}
                    lChildren={props.rChildren}
                    lIsWithRightArrow={props.rIsWithRightArrow}
                    onClick={props.rBtnClick}
                    lDataLayer={props?.rDataLayer}
                    lDisabled={props?.rDisabled}
                ></EcoButton>
            )}
        </div>
    );
};

export default EcoButtonDouble;
